import React, { useState } from 'react'
import styles from './styles.module.css'

function PhoneNumbers({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Toggle expand/collapse state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  // Limit the display of phone numbers to 5 unless expanded
  const phonesToShow = isExpanded
    ? record.phones
    : record.phones?.slice(0, 5) || []

  return (
    <div className={styles.PhoneNumbersBusinessContainer}>
      <span className={styles.PhoneNumbersBusinessTitle}>Phone Numbers</span>

      <div className={styles.PhoneNumbersBusinessList}>
        {phonesToShow.length > 0 ? (
          phonesToShow.map((phone, index) => (
            <span key={index} className={styles.PhoneNumbersBusinessItem}>
              {phone}
            </span>
          ))
        ) : (
          <span className={styles.NoPhoneNumbers}>N/A</span>
        )}
      </div>

      {/* Show the expand button only if there are more than 5 phone numbers */}
      {record.phones && record.phones.length > 5 && (
        <button
          className={styles.PhoneNumbersBusinessButton}
          onClick={toggleExpand}
        >
          {isExpanded ? 'Show less' : `Expand all (${record.phones.length})`}
        </button>
      )}
    </div>
  )
}

export default PhoneNumbers
